import React, { FC } from "react";
import { WPPost } from "../../../constants/types";
import { ChallengingSituationsACF } from "../../../constants/types/acf";
import { getWpPostUrl } from "../../../utils";
import { ChalleningSituationHomeCard } from "../../molecules/ChallengingSituationHomeCard";
import { useChallengingSitationCardSize } from "../../molecules/ChallengingSituationHomeCard/utils";
import { useCardCarousel } from "../Carousel";
import { CarouselSection } from "../CarouselSection";

type Props = {
    id?: string;
    title: string;
    conditions: WPPost<ChallengingSituationsACF>[];
};

export const HomeChallengingSituations: FC<Props> = props => {
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(
        props.conditions.length,
        useChallengingSitationCardSize,
    );

    return (
        <CarouselSection
            id={props.id}
            title={props.title}
            carousel={{
                onScrollLeft: scrollLeft,
                onScrollRight: scrollRight,
                canScroll,
                displayControl: true,
                content: (
                    <Carousel>
                        {props.conditions.map(item => (
                            <ChalleningSituationHomeCard
                                key={item.id}
                                to={getWpPostUrl(item)}
                                title={item.title.rendered}
                            />
                        ))}
                    </Carousel>
                ),
            }}
        />
    );
};
